






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
    name: 'ldw-tooltip'
})

export default class SideNavigationComponent extends Vue {
    // properties
    @Prop(String) private readonly tool: string | undefined
    @Prop(String) private readonly tip: string | undefined
    // data
    // methods
}
